// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zq2A","type":"styles_type__1B22-","choices":"styles_choices__1_7Lt"};